<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <div class="d-flex mb-4">
        <h2>{{ $t("memberDataSection.farmerView") }}</h2>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          dark
          class="mr-2 mb-2"
          @click="$router.go(-1)"
        >
          {{ $t("back") }}
        </v-btn>
        <v-btn
          color="primary"
          class="mr-2 mb-2"
          v-show="$can($permissions.can_update_farm.value)"
          @click="handleEdit"
        >
          {{ $t("edit") }}
        </v-btn>
        <v-btn
          :color="isActive ? 'error' : 'primary'"
          outlined
          class="mr-2 mb-2"
          v-show="isStatusKnown && $can($permissions.can_delete_farm.value)"
          @click="onToggleStatusClick"
        >
          {{ isActive ? $t("addEdituser.deactivateAct") : $t("addEdituser.activateAct") }}
        </v-btn>
      </div>
      <template v-if="hasFarmer">
        <v-card class="cards mb-6" flat>
          <v-row class="mb-4">
            <div class="text-block">
              <div class="img-box mr-4">
                <v-img
                  v-if="farmer.user && farmer.user.profilePicUrl"
                  class="profile-img"
                  :src="farmer.user.profilePicUrl"
                ></v-img>
                <v-img v-else class="profile-img" src="/img/user.jpg"></v-img>
              </div>
              <div class="inner-text-block">
                <h4 class="mb-2">
                  {{ farmer.user.firstName }} {{ farmer.user.middleName }}
                  {{ farmer.user.lastName }}
                </h4>
              </div>
            </div>
          </v-row>
          <v-row>
            <v-col lg="3" md="4" sm="6" xs="12">
              <v-card min-height="120" class="pa-2 green2 elevation-0">
                <v-list class="green2">
                  <v-list-item three-line>
                    <v-list-item-content>
                      <v-list-item-subtitle
                        >{{ $t("userslist.registrationDate") }}
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("userslist.registrationDate") }}</span>
                        </v-tooltip>
                      </v-list-item-subtitle>
                      <v-list-item-title class="text-h6 mt-2">
                        {{ farmer.user.registration || "N/A" }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
            <v-col lg="3" md="4" sm="6" xs="12">
              <v-card min-height="120" class="pa-2 green2 elevation-0">
                <v-list class="green2">
                  <v-list-item three-line>
                    <v-list-item-content>
                      <v-list-item-subtitle>
                        {{ $t("country") }}
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("country") }}</span>
                        </v-tooltip>
                      </v-list-item-subtitle>
                      <v-list-item-title class="text-h6 mt-2">
                        {{ farmer.user.country || "N/A" }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
            <v-col lg="3" md="4" sm="6" xs="12">
              <v-card min-height="120" class="pa-2 green2 elevation-0">
                <v-list class="green2">
                  <v-list-item three-line>
                    <v-list-item-content>
                      <v-list-item-subtitle>
                        {{ $t("email") }}
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("email") }}</span>
                        </v-tooltip>
                      </v-list-item-subtitle>
                      <v-list-item-title class="text-h6 mt-2">
                        {{ farmer.user.email || "N/A" }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
            <v-col lg="3" md="4" sm="6" xs="12">
              <v-card min-height="120" class="pa-2 green2 elevation-0">
                <v-list class="green2">
                  <v-list-item three-line>
                    <v-list-item-content>
                      <v-list-item-subtitle
                        >{{ $t("deforestation.phoneNumber") }}
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("deforestation.phoneNumber") }}</span>
                        </v-tooltip>
                      </v-list-item-subtitle>
                      <v-list-item-title class="text-h6 mt-2">
                        {{ farmer.user.mobile || "N/A" }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
            <v-col lg="3" md="4" sm="6" xs="12">
              <v-card min-height="120" class="pa-2 green2 elevation-0">
                <v-list class="green2">
                  <v-list-item three-line>
                    <v-list-item-content>
                      <v-list-item-subtitle>
                        {{ $t("reports.gen") }}
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("reports.gen") }}</span>
                        </v-tooltip>
                      </v-list-item-subtitle>
                      <v-list-item-title class="text-h6 mt-2">
                        {{ farmer.user.gender || "N/A" }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
            <v-col lg="3" md="4" sm="6" xs="12">
              <v-card min-height="120" class="pa-2 green2 elevation-0">
                <v-list class="green2">
                  <v-list-item three-line>
                    <v-list-item-content>
                      <v-list-item-subtitle
                        >{{ $t("farm.provinceState") }}
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("farm.provinceState") }}</span>
                        </v-tooltip>
                      </v-list-item-subtitle>
                      <v-list-item-title class="text-h6 mt-2">
                        {{ farmer.user.state || "N/A" }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
            <v-col lg="3" md="4" sm="6" xs="12">
              <v-card min-height="120" class="pa-2 green2 elevation-0">
                <v-list class="green2">
                  <v-list-item three-line>
                    <v-list-item-content>
                      <v-list-item-subtitle>
                        {{ $t("userslist.cityTown") }}
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("userslist.cityTown") }}</span>
                        </v-tooltip>
                      </v-list-item-subtitle>
                      <v-list-item-title class="text-h6 mt-2">
                        {{ farmer.user.city || "N/A" }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
            <v-col lg="3" md="4" sm="6" xs="12">
              <v-card min-height="120" class="pa-2 green2 elevation-0">
                <v-list class="green2">
                  <v-list-item three-line>
                    <v-list-item-content>
                      <v-list-item-subtitle>
                        {{ $t("address") }}
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("address") }}</span>
                        </v-tooltip>
                      </v-list-item-subtitle>
                      <v-list-item-title class="text-h6 mt-2">
                        {{ farmer.user.address || "N/A" }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
        <v-card flat>
          <v-container fluid>
            <h2 class="ml-2">{{ $t("reports.regions.farms") }}</h2>
          </v-container>
          <farm-list
            :key="$route.params.id"
            class="pa-6"
            :headers="farmListHeader"
            :farms="farms"
            :totalFarms="totalUserFarm"
            :toggleSelection="false"
            @fetchFarmData="getUserFarmDetail"
          />
        </v-card>
        <!-- <div class="footer-card mt-10">
          <div class="btn-block mr-6">
            <v-btn
              @click="$router.go(-1)"
              x-large
              min-width="120"
              depressed
              color="primary"
              outlined
              class="views-btn mr-4"
              >{{ $t("back") }}</v-btn
            >
            <v-btn
              :to="{ name: 'view_all_farms', params: { id: farmer.user.id } }"
              x-large
              min-width="120"
              color="primary"
              class="views-btn"
              >{{ $t("memberDataSection.viewAllFarms") }}</v-btn
            >
          </div>
        </div> -->
      </template>
      <v-card v-if="!hasFarmer && !mixingIsLoading">
        <div class="py-16 text-center">
          <img src="/icons/nodata.svg" /><br />
          <strong class="red--text">
            {{ $t("noRecordFound") }}
          </strong>
        </div>
      </v-card>
    </v-container>

    <ConfirmationBox
      :dialog="showConfirmationBox"
      :message="confirmationMessage"
      :dialogTitle="confirmationDialogTitle"
      :confirmButtonText="confirmationButtonText"
      @close="showConfirmationBox = false"
      @confirm="handleToggleStatusConfirm"
    />

     <!-- Edit App User Dialog -->
    <EditAppUser 
      v-if="editUserDialog && selectedFarmer"
      :dialogU="editUserDialog" 
      :user="selectedFarmer"
      :isMarketPlaceUser="false"
      @closeUpdateUser="closeEditUserDialog"
      @appUserUpdated="handleUserUpdated"
    />
  </div>
</template>
<script>
import loadingMixin from "@/mixins/LoadingMixin";
import getPermittedActions from "@/mixins/GetPermittedActions";
import { mapGetters } from "vuex";
import { convertSizeIntoBaseUnit } from "@/utils.js";
import _ from "lodash";
import FarmList from "./components/FarmList.vue";
import ConfirmationBox from "./components/ConfirmationBox.vue";
import EditAppUser from "@/views/user/EditAppUser.vue";
import UserService from "@/_services/UserService";

export default {
  components: { FarmList, ConfirmationBox, EditAppUser },
  mounted() {
    this.getFarmerDetail();
  },
  watch: {
    // Same route, different farmer (e.g. browser back/forward) — component is reused
    "$route.params.id"() {
      this.getFarmerDetail();
    },
  },
  computed: {
    ...mapGetters({
      farmer: "memberData/farmerDetail",
      farms: "memberData/userAllFarms",
      totalUserFarm: "memberData/userFarmCount"
    }),
    hasFarmer() {
      return !_.isEmpty(this.farmer) && !!this.farmer.user;
    },
    // The status endpoint toggles, so never guess: if the API didn't send
    // `active`, hide the button rather than risk flipping an active user off.
    isStatusKnown() {
      const active = this.farmer?.user?.active;
      return this.hasFarmer && active !== undefined && active !== null;
    },
    isActive() {
      const active = this.farmer?.user?.active;
      return active === true || Number(active) === 1;
    },
    primaryFarmId() {
      return this.farmer?.farmInformation?.farmID || null;
    },
    breadcrumbs() {
      return [
        {
          text: this.$t("dashboard"),
          disabled: false,
          to: { name: "Users" },
          exact: true,
        },
        {
          text: this.$t("memberDataSection.farmers"),
          disabled: false,
          to: { name: "Farmers" },
          exact: true,
        },
        {
          text: this.$t("memberDataSection.farmersDetails"),
          disabled: true,
        },
      ];
    },
    farmListHeader() {
      return [
        {
          text: this.$t("farm.farmNameId"),
          align: "start",
          value: "farmNameId",
          class: "black--text",
        },
        {
          text: this.$t("farm.farmId"),
          align: "start",
          value: "id",
          class: "black--text",
        },
        {
          text: this.$t("country"),
          align: "start",
          value: "country",
          class: "black--text",
        },
        {
          text: this.$t("deforestation.farmAddress"),
          align: "start",
          value: "farmAddress",
          class: "black--text",
        },
        {
          text: this.$t("region"),
          align: "start",
          value: "region",
          class: "black--text",
        },
        {
          text: this.$t("farm.area"),
          align: "start",
          value: "area",
          class: "black--text",
        },
        {
          text: this.$t("farm.regDate"),
          align: "start",
          value: "createdAt",
          class: "black--text",
        },
        {
          text: "",
          align: "start",
          value: "action",
          class: "black--text",
          sortable: false,
        },
      ];
    },
    confirmationDialogTitle() {
      return this.isActive
        ? this.$t("addEdituser.deactivateAct")
        : this.$t("addEdituser.activateAct");
    },
    confirmationButtonText() {
      return this.confirmationDialogTitle;
    },
    confirmationMessage() {
      return this.isActive
        ? this.$t("addEdituser.areYouSureYouWantToDeactivateThisFarmer")
        : this.$t("addEdituser.areYouSureYouWantToActivateThisFarmer");
    },
  },
  data() {
    return {
      showConfirmationBox: false,
      editUserDialog: false,
      selectedFarmer: null,
    };
  },
  methods: {
        // Edit User Dialog event handlers
    closeEditUserDialog() {
      this.editUserDialog = false;
      this.selectedFarmer = null;
    },

    handleUserUpdated(result) {
      if (result.success) {
        this.getFarmerDetail();
      }
    },
     async handleEdit() {
      try {
        const response = await UserService.getUserDetails(this.$route.params.id);
        const station = response && response.data ? response.data : null;

        if (station) {
          // Map API response to EditAppUser expected structure (same as list view)
          this.selectedFarmer = {
            id: station.id,
            firstName: station.firstName || "",
            middleName: station.middleName || "",
            lastName: station.lastName || "",
            email: station.email || "",
            mobile: station.mobile || "",
            phoneNumber: station.mobile || "",
            country: station.country || "",
            countryId: station.countryId || "",
            countryCode: station.countryIsoCode || station.countryCode || "",
            stateId: station.stateId || "",
            district: station.district || "",
            village: station.village || "",
            city: station.city || "",
            address: station.address || "",
            userTribe: station.userTribe || "",
            website: station.website || "",
            id_number: station.id_number || "",
            active: Boolean(station.active),
            user_membership: Array.isArray(station.user_membership) ? station.user_membership : [],
            activation: Array.isArray(station.activation) ? station.activation : [],
          };

          this.editUserDialog = true;
        }
      } catch (err) {
        this.$notify({
          text: err?.data?.message || "Error fetching buying station details",
          type: "error",
        });
      }
    },
    convertSizeIntoBaseUnit,
    getFarmerDetail() {
      this.startLoading();
      return this.$store
        .dispatch("memberData/getFarmerDetail", {
          userId: this.$route.params.id,
        })
        .then(() => this.stopLoading())
        .catch(() => this.stopLoading());
    },
    // Called by FarmList (on create and on every filter/page change)
    getUserFarmDetail(options) {
      this.startLoading();
      this.$store
        .dispatch("memberData/getFarmersViewAllFarms", {
          ...options,
          userId: this.$route.params.id,
        })
        .then(() => this.stopLoading())
        .catch(() => this.stopLoading());
    },
    onToggleStatusClick() {
      this.showConfirmationBox = true;
    },
    async handleToggleStatusConfirm() {
      this.showConfirmationBox = false;
      if (!this.isStatusKnown) return;
      const wasActive = this.isActive;
      this.startLoading();
      try {
        // Backend toggles: active -> inactive (and releases activation keys), inactive -> active
        const res = await UserService.toggleUserStatus(this.farmer.user.id);
        if (!res?.success) {
          throw new Error(res?.message);
        }
        this.$notify({
          title: wasActive
            ? this.$t("addEdituser.userDeactivated")
            : this.$t("addEdituser.userActivated"),
          type: "success",
        });
        await this.getFarmerDetail();
      } catch (e) {
        this.$notify({
          title: this.$t("addEdituser.userNotUpdated"),
          type: "error",
        });
      } finally {
        this.stopLoading();
      }
    },
  },
  mixins: [loadingMixin, getPermittedActions],
};
</script>
<style lang="scss" scoped>
::v-deep .profile-img {
  height: 134px;
  width: 134px;
  border-radius: 50%;
}

::v-deep .cards {
  padding: 40px;
}

::v-deep .text-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

::v-deep .card-titles {
  height: 54px;
  background: #e5f8f1;
  line-height: 26px;
}

::v-deep .no-radius {
  border-radius: 0px;
}

::v-deep .height-300 {
  height: 300px;
}

::v-deep .row-box {
  display: flex;
  flex-wrap: wrap;
}

::v-deep .cmr {
  margin-right: 31px;
}

@media only screen and (max-width: 700px) {
  ::v-deep .row-box {
    flex-direction: column;
  }
  ::v-deep .cmr {
    margin-right: 0 !important;
    margin-bottom: 16px !important;
  }
}

::v-deep .row-box .flex-1 {
  flex: 0 0 48%;
  margin-bottom: 15px;
}

::v-deep .footer-card {
  display: flex;
  justify-content: center;
}
</style>
